import { ReactElement } from 'react'

import { IconProps } from '@hhgtech/hhg-components'
import {
  Article,
  Calendar,
  Clickable,
  ClinicPin,
  Scale,
  Screener,
  Stethoscope,
  Video,
} from '@hhgtech/icons/other'

import Community from 'components/atoms/icons/Community'
import Doctor from 'components/atoms/icons/Doctor'
import Form from 'components/atoms/icons/Form'
import GraphicBag from 'components/atoms/icons/GraphicBag'
import GraphicChat from 'components/atoms/icons/GraphicChat'
import GraphicDocument from 'components/atoms/icons/GraphicDocument'
import GraphicTag from 'components/atoms/icons/GraphicTag'
import Pill from 'components/atoms/icons/Pill'
import QuestionMarkBubble from 'components/atoms/icons/QuestionMarkBubble'
import Soya from 'components/atoms/icons/Soya'
import Tag from 'components/atoms/icons/Tag'
import Tower from 'components/atoms/icons/Tower'
import Virus from 'components/atoms/icons/Virus'
import { SessionType } from 'interfaces/types'

import SimilacShield from 'components/atoms/icons/SimilacShield'
import SimilacVideo from 'components/atoms/icons/SimilacVideo'
import SimilacArticle from 'components/atoms/icons/SimilacArticle'
import SimilacLeadgen from 'components/atoms/icons/SimilacLeadgen'
import HpvVaccine from 'components/atoms/icons/HpvVaccine'
import Quote from 'components/atoms/icons/Quote'
import SimilacAskDoctor from 'components/atoms/icons/SimilacAskDoctor'
import { DetectPageReturnType } from 'hooks/useDetectSCpage'
import Activities from 'components/atoms/icons/Activities'

export type MapIcons = {
  [key in SessionType]?: ReactElement<IconProps>
}

export const getIconBySession = ({
  isTaganil,
  isRoche,
  isCarePath,
  isSoya,
  isSimilac,
}: DetectPageReturnType) => ({
  ...DEFAULT_MAP_ICON_BY_SESSION,
  ...(isTaganil
    ? {
        [SessionType.CHAT_WITH_EXPERT]: <Stethoscope />,
      }
    : isRoche
    ? {
        [SessionType.EMBEDDING_DOCTORS]: <GraphicDocument />,
        [SessionType.EMBEDDING_RISKSCREENER]: <GraphicBag />,
        [SessionType.CLICKABLE_BANNER]: <GraphicChat />,
        [SessionType.ARTICLES]: <GraphicTag />,
      }
    : isCarePath
    ? {
        [SessionType.EMBEDDING_DOCTORS]: <Doctor />,
        [SessionType.EMBEDDING_RISKSCREENER]: <HpvVaccine />,
        [SessionType.EMBEDDING_RISKSCREENER_MULTI]: <HpvVaccine />,
        [SessionType.CLINIC_LOCATORS]: <Tower />,
        [SessionType.ARTICLES]: <Virus />,
      }
    : isSimilac
    ? {
        [SessionType.EMBEDDING_RISKSCREENER]: <SimilacShield />,
        [SessionType.VIDEOS]: <SimilacVideo />,
        [SessionType.ARTICLES]: <SimilacArticle />,
        [SessionType.LEADGEN]: <SimilacLeadgen />,
        [SessionType.STATIC_BANNER]: <SimilacAskDoctor />,
      }
    : isSoya
    ? {
        [SessionType.LEADGEN]: <Tag />,
      }
    : {}),
})

export const DEFAULT_MAP_ICON_BY_SESSION: MapIcons = {
  [SessionType.HERO_BANNER_DEFAULT]: <Activities />,
  [SessionType.HERO_BANNER_FULLWIDTH]: <Activities />,
  [SessionType.EMBEDDING_DOCTORS]: <Calendar />,
  [SessionType.CLINIC_LOCATORS]: <ClinicPin />,
  [SessionType.EMBEDDING_RISKSCREENER]: <Screener />,
  [SessionType.EMBEDDING_RISKSCREENER_MULTI]: <Screener />,
  [SessionType.VIDEOS]: <Video isSolid />,
  [SessionType.ARTICLES]: <Article />,
  [SessionType.CLICKABLE_BANNER]: <Clickable />,
  [SessionType.CHAT_WITH_EXPERT]: <QuestionMarkBubble />,
  [SessionType.ECOMMERCE_PRODUCS]: <Pill />,
  [SessionType.COMMUNITY_WITH_POSTS]: <Community />,
  [SessionType.LEADGEN]: <Form />,
  [SessionType.SOYA_EXTERNAL_LINK]: <Soya />,
  [SessionType.SOYA_OPEN_CHAT]: <Stethoscope />,
  [SessionType.HEALTH_TOOL]: <Scale />,
  [SessionType.QUOTATION]: <Quote />,
  [SessionType.CONTENT_EXPERT]: <Stethoscope />,
}
